
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M3.6 11.313h31.35v6.65H3.6zM8.35 22.713H18.8v2.85H8.35zM8.35 28.413H18.8v2.85H8.35zM20.7 22.713h10.45v2.85H20.7zM34 26.038l2.821 6.678 6.679 2.822-6.679 2.82L34 45.039l-2.821-6.68-6.679-2.82 6.679-2.822zM41.6 22.238l1.128 2.671 2.672 1.129-2.672 1.128-1.128 2.671-1.129-2.671-2.671-1.128 2.671-1.129z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M37.8 22.238V9.413a.95.95 0 0 0-.95-.95H5.5a.95.95 0 0 0-.95.95v25.65c0 .524.425.95.95.95h17.338M5.05 16.512H37.3"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-linejoin":"round","d":"M10.75 23.163h8.5M23.1 23.163h8.5M10.75 28.863h8.5"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linejoin":"round","d":"m34.95 24.138 2.821 6.678 6.679 2.822-6.679 2.82-2.821 6.68-2.821-6.68-6.679-2.82 6.679-2.822z"}})])
          )
        }
      }
    